import gql from 'graphql-tag'

export default gql`
  query SearchParameters {
    searchParameters {
      attribute
      type
      regex
      autocompleteList
      description
    }
  }
`
